'use strict';

import jQuery from 'jquery';
import select2 from 'select2/dist/js/select2.full';

select2(window, jQuery);

jQuery(function ($) {
    $('.select2-replace').each(function () {
        let $this = $(this);
        $this.select2({
            minimumInputLength: 3,
            minimumResultsForSearch: 25,
            dropdownParent: $this.parent(),
            language: {
                searching: function () {
                    return "Loading...";
                }
            }
        });
    });

    $('.select2-schools').each(function () {
        let $this = $(this);
        $this.select2({
            minimumInputLength: 3,
            minimumResultsForSearch: 25,
            dropdownParent: $this.parent(),
            ajax: {
                url: window.school_search_url,
                dataType: 'json'
            },
            templateResult: option => {
                if (option.html) {
                    return $(option.html);
                }

                return option.text;
            },
            language: {
                searching: function () {
                    return "Loading...";
                },
                inputTooShort: function (args) {
                    return `Please enter at least ${args.minimum} characters`;
                }
            }
        });
    });
});
